export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref5044.e9da82dd.jpg";